import React from 'react';

export const NotificationDispatch = React.createContext(() => {});
